import { cn } from "@lib/cn";
import { VERSIONS_TABLE_SIZES } from "@pages/analytics/constants";

const BASE_CLASSNAME =
  "tw-px-2 tw-text-xs tw-font-sans tw-h-10 tw-text-blue-500 tw-font-medium tw-flex tw-items-center";
export const VersionsTableHeader = () => {
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-solid tw-border-blue-100 tw-sticky tw-top-0 tw-z-[1] tw-bg-white">
      <div
        className={cn(
          BASE_CLASSNAME,
          "tw-flex-auto tw-pl-4 tw-pr-2 tw-min-w-0 tw-w-80 tw-shrink-0 tw-mr-auto -2xl:tw-w-52 -md:tw-w-60",
        )}
      >
        Name
      </div>
      <div
        className={BASE_CLASSNAME}
        style={{ width: VERSIONS_TABLE_SIZES.READERS }}
      >
        Readers
      </div>
      <div
        className={BASE_CLASSNAME}
        style={{ width: VERSIONS_TABLE_SIZES.AVG_READING_TIME }}
      >
        Avg reading time
      </div>
      <div
        className={BASE_CLASSNAME}
        style={{ width: VERSIONS_TABLE_SIZES.ENGAGED_USERS }}
      >
        Engaged users
      </div>
      <div
        className={BASE_CLASSNAME}
        style={{ width: VERSIONS_TABLE_SIZES.AVG_PROGRESS }}
      >
        Avg progress
      </div>
      <div
        className={BASE_CLASSNAME}
        style={{ width: VERSIONS_TABLE_SIZES.CREATED_AT }}
      >
        Created at
      </div>
      <div
        className={BASE_CLASSNAME}
        style={{ width: VERSIONS_TABLE_SIZES.OWNER }}
      >
        Owner
      </div>
    </div>
  );
};
